import { produce } from "immer";
import { tDrawerFilterToggleAction, tModalsAction, tModalsState, tSettingsModalVisibleAction } from "./types";

const kDefaultModalsState: tModalsState = {
  settingsModalVisible: false,
  settingsFilterVisible: false,
  promoCartConfirmVisible: false,
  modals: [],
  tooltip: {},
};

const handleSettingsModalChange = (draft: tModalsState, action: tSettingsModalVisibleAction): tModalsState => {
  draft.settingsModalVisible = action.settingsModalVisible;
  return draft;
};
const handleDrawerFilterChange = (draft: tModalsState, action: tDrawerFilterToggleAction): tModalsState => {
  draft.settingsFilterVisible = action.settingsFilterVisible;
  return draft;
};

export const ModalsReducer = produce(
  (draft: tModalsState = kDefaultModalsState, action: tModalsAction): tModalsState => {
    switch (action.type) {
      case "SETTINGS_MODAL_TOGGLE":
        return handleSettingsModalChange(draft, action);
      case "DRAWER_FILTER_TOGGLE":
        return handleDrawerFilterChange(draft, action);
      case "PROMO_CART_MODAL_TOGGLE":
        draft.promoCartConfirmVisible = action.promoCartConfirmVisible;
        draft.promoCallback = action.promoCallback;
        return draft;
      case "OPEN_MODAL":
        draft.modals = [...draft.modals, action.payload];
        return draft;
      case "CLOSE_MODAL":
        draft.modals = draft.modals.filter((modal) => modal.id !== action.payload);
        return draft;
      case "OPEN_TOOLTIP":
        draft.tooltip = action.payload;
        return draft;
      case "TOGGLE_TOOLTIP":
        draft.tooltip = { ...action.payload, isOpen: !draft.tooltip.isOpen };
        return draft;
      case "CLOSE_TOOLTIP":
        draft.tooltip.isOpen = false;
        return draft;
      default:
        return draft;
    }
  },
);
